
<template>
  <div style="width:100%;height:100%;">
           <el-select v-model="type">
              <el-option label="标绘红线" value="1"></el-option>
              <el-option label="标绘中心点" value="2"></el-option>
              <el-option label="标绘周边兴趣点" value="3"></el-option>
          </el-select>

       <div style="width:100%;display: flex;height: calc(100% - 42px);border: 1px solid #dedede;" id="id1">
         <div style="width:80%;height:100%;border-right: 1px solid #dedede;" class="mainMap">
            <photosphereviewer @plotMarkerEvent="plotMarkerEventHandler" :navbarStatusArray="navbarStatusArray" :tableImgHeight="'600px'" :landinfo ="landinfo" ></photosphereviewer>
         </div>
         <div style="height:100%;width: 20%;">
             <div style="font-size: 16px;color: #333333;border-bottom: 1px solid #dddddd;height: 46px;line-height: 45px;padding: 0px 10px;">
                 地块列表(0)
             </div>
             <div style="height: calc(100% - 48px);  padding-left: 10px;font-size: 23px;">
                 <el-scrollbar style="height: 100%;">
                      <ul>
                         <li v-for="(item, index) in list" :key="'list'+index">
                             <el-checkbox :checked="item.checked" :key="index" :label="`坐标点${index+1}`"  @change="checkBoxHandler(item)"></el-checkbox>
                             <el-input style="width:150px" v-model="item.name" ></el-input>
                             <el-button @click="dingwei(item)" size="small" icon="el-icon-plus" style="border: 1px dashed #d9d9d9">删除</el-button>
                         </li>
                     </ul>
                 </el-scrollbar>
             </div>
         </div>
      </div>
   </div>

</template>
<script>
import Vue from 'vue'
import photosphereviewer from 'components/main-map/mobilephotosphereviewer'
export default {
  name: 'edit',
  components: {
    photosphereviewer
  },
  props: {
    landinfo: null
  },
  data() {
    return {
      navbarStatusArray: ['fullscreen'],
      type: '1',
      list: [
      ]
    }
  },
  created() {

  },
  computed: {

  },
  mounted() {
    //
  },
  watch: {
    landinfo: {
      handler(newValue, oldValue) {
        if (newValue != null) {
          newValue.plot = true
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    plotMarkerEventHandler(data) {
      debugger
      const objec = {}
      objec.latlng = data
      objec.name = ''
      this.list.push(objec)
    },
    checkBoxHandler() {
      //
    },
    dingwei(item) {
      for (let index = 0; index < this.list.length; index++) {
        const element = this.list[index]
        if (item === element) {
          this.list.splice(index, 1)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mainMap {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: default;
  position: relative;
}
.el-scrollbar{
    ::v-deep{
        .el-scrollbar__wrap{
            overflow-x: hidden;
        }
    }
}
</style>
